export const JiraWorkManagementMarkInverse = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.852 9.8008L22.156 32.2848C29.408 34.3338 35.191 31.6698 37.407 22.9218L40.731 9.7998H27.852V9.8008Z"
      fill="url(#paint0_linear_818_559)"
    />
    <path
      d="M20.148 40.2026L25.844 17.7186C18.592 15.6696 12.809 18.3336 10.593 27.0816L7.26904 40.2036H20.148V40.2026Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_559"
        x1="20.469"
        y1="32.3678"
        x2="32.167"
        y2="18.3098"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
